import { Skill } from "./interfaces";

export const languages = [
  {
    name: "Javascript",
    level: "Experienced",
    type: "language",
    experience: "2017 - Present",
    tags: ["Web", "NodeJs", "Vue", "GoogleSheet"],
    image: "javascript.svg",
  },
  {
    name: "Typescript",
    level: "Experienced",
    type: "language",
    experience: "2018 - Present",
    tags: ["Web", "NodeJs", "NestJs", "Vue"],
    image: "typescript.svg",
  },
  {
    name: "Python",
    level: "Intermediate",
    type: "language",
    experience: "2018 - Present",
    tags: ["Programming", "Data Science", "Data"],
    image: "python.svg",
  },

  {
    name: "Java",
    level: "Intermediate",
    type: "language",
    experience: "2018 - Present",
    tags: ["DS", "Android"],
    image: "java.svg",
  },
  {
    name: "Dart",
    level: "Intermediate",
    type: "language",
    experience: "2022 - Present",
    tags: ["Mobile", "Web", "Flutter"],
    image: "Dart.svg",
  },
  {
    name: "Rust",
    level: "Beginner",
    type: "language",
    experience: "2020 - Present (Learning)",
    tags: ["System", "Programming"],
    image: "rust.svg",
  },

  {
    name: "C++",
    level: "Intermediate",
    type: "language",
    experience: "2013 - Don't use it any more!",
    tags: ["System", "Programming"],
    image: "c++.svg",
  },
  {
    name: "PHP",
    level: "Intermediate",
    type: "language",
    experience: "2013 - Don't use it any more!",
    tags: ["Programming", "Backend"],
    image: "php.svg",
  },
  {
    name: "CSS",
    level: "Experienced",
    type: "language",
    experience: "2013 - Present",
    tags: ["Web", "Markup", "with SASS & Less"],
    image: "css-3.svg",
  },
  {
    name: "HTML",
    level: "Experienced",
    type: "language",
    experience: "2013 - Present",
    tags: ["Web", "Markup"],
    image: "html-5.svg",
  },
] as Array<Skill>;
